export const ITipEventsRepositoryType = Symbol('ITipEventsRepository');
